import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=e3f34494&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=e3f34494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f34494",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3f34494')) {
      api.createRecord('e3f34494', component.options)
    } else {
      api.reload('e3f34494', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=e3f34494&scoped=true&", function () {
      api.rerender('e3f34494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Portefeuille/Home.vue"
export default component.exports